import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import router from "./router";
// mitt
import mitt from "mitt";

import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import VueApexCharts from "vue3-apexcharts";
import './assets/new-main.css';

import {
  Alert,
  Button,
  Col,
  List,
  Row,
  Skeleton,
  Switch,
  Tooltip,
  Spin,
  Modal,
  Input,
  Select,
  Popover,
  Space,
  Empty,
} from "ant-design-vue";
import "ant-design-vue/dist/reset.css";

import './registerServiceWorker'
import 'leaflet/dist/leaflet.css';

loadFonts();

const app = createApp(App);

const emitter = mitt();
app.config.globalProperties.emitter = emitter;

app.use(Button);
app.use(Col);
app.use(List);
app.use(Row);
app.use(Alert);
app.use(Skeleton);
app.use(Switch);
app.use(Tooltip);
app.use(Spin);
app.use(Modal);
app.use(Input);
app.use(Popover);
app.use(Select);
app.use(Space);
app.use(Empty);
app.use(VueApexCharts);

app.component("VueDatePicker", VueDatePicker);
app.component("vue-select", vSelect);

app.use(router);
app.use(store);
app.use(vuetify);
app.mount("#app");
